<template>
  <div v-if="show">
    <table class="table">
      <tbody>
        <tr>
          <th>ID</th>
          <td>{{ show.id }}</td>
        </tr>
        <tr>
          <th>Name</th>
          <td>{{ show.name }}</td>
        </tr>
        <tr>
          <th>Finished</th>
          <td>{{ show.finished }}</td>
        </tr>
        <tr>
          <th>Video Quality</th>
          <td>{{ show.video_quality }}</td>
        </tr>
        <tr>
          <th>Audio Quality</th>
          <td>{{ show.audio_quality }}</td>
        </tr>
        <tr>
          <th>Subtitles</th>
          <td>{{ show.subtitles }}</td>
        </tr>
        <tr>
          <th>Chapters</th>
          <td>{{ show.chapters }}</td>
        </tr>
        <tr>
          <th>Titles</th>
          <td>{{ show.titles }}</td>
        </tr>
        <tr>
          <th>Metadata</th>
          <td>{{ show.metadata }}</td>
        </tr>
        <tr>
          <th>Embedded Images</th>
          <td>{{ show.embedded_images }}</td>
        </tr>
        <tr>
          <th>Container</th>
          <td>{{ show.container }}</td>
        </tr>
        <tr>
          <th>Video Format</th>
          <td>{{ show.video_format }}</td>
        </tr>
        <tr>
          <th>Audio Format</th>
          <td>{{ show.audio_format }}</td>
        </tr>
        <tr>
          <th>Source</th>
          <td>{{ show.source }}</td>
        </tr>
        <tr>
          <th>Duration</th>
          <td>{{ show.duration }}</td>
        </tr>
        <tr>
          <th>Size</th>
          <td>{{ show.size }}</td>
        </tr>
      </tbody>
    </table>

    <router-link :to="{ name: 'ShowIndex' }" class="btn btn-secondary">Back</router-link>
  </div>

  <div v-else>
    There's actually nothing here.
  </div>
</template>

<script>

import { ShowService } from '@/common/services/show.service';

export default {
  name: 'ShowShow',
  components: {

  },
  props: [
    'id',
  ],
  data() {
    return {
      show: null,
    };
  },
  created() {
    this.getShow(this.id);
  },
  methods: {
    getShow(params) {
      ShowService.get(params).then((response) => {
        this.show = response.data;
      });
    }
  },
};

</script>

<style lang="scss" scoped>

</style>
